import {
  Icon as TablerIcon,
  IconBuilding,
  IconBuildingWarehouse,
  IconCamper,
  IconCar,
  IconHome,
  IconLockOpen,
  IconMotorbike,
  IconPlane,
  IconShip,
  IconTextScan2,
} from '@tabler/icons-react';
import AssetClassConfig, { AssetClassId } from 'types/assetClass';

import { isUnsecEnabled } from '../../../../flags';

export const SIDE_NAV_CONFIG: {
  routeSegment: AssetClassId;
  icon: TablerIcon;
  text: string;
  disabled?: boolean;
  dynamicRouteFn?: (params: Record<string, string>) => string;
}[] = [
  {
    routeSegment: 'home',
    icon: IconHome,
    text: AssetClassConfig.HOME.label,
  },
  {
    routeSegment: 'auto',
    icon: IconCar,
    text: AssetClassConfig.AUTO.label,
  },
  {
    routeSegment: 'rv',
    icon: IconCamper,
    text: 'RV',
    disabled: true,
  },
  {
    routeSegment: 'unsecuredpersonal',
    icon: IconLockOpen,
    text: AssetClassConfig.UNSECPERSONAL.label,
    disabled: !isUnsecEnabled(),
  },
  {
    routeSegment: 'cre',
    icon: IconBuilding,
    text: AssetClassConfig.CRE.label,
  },
  {
    routeSegment: 'aircraft',
    icon: IconPlane,
    text: 'Aircraft',
    disabled: true,
  },
  {
    routeSegment: 'motorcycle',
    icon: IconMotorbike,
    text: 'Motorcycle',
    disabled: true,
  },
  {
    routeSegment: 'warehouse',
    icon: IconBuildingWarehouse,
    text: 'Warehouse',
    disabled: true,
  },
  {
    routeSegment: 'marine',
    icon: IconShip,
    text: 'Marine',
    disabled: true,
  },
  {
    routeSegment: 'revolving',
    icon: IconTextScan2,
    text: 'Revolving',
    disabled: true,
  },
];
